<script setup lang="ts">
/* eslint-disable max-len */
</script>

<template>
  <svg width="56" height="56" viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fill-rule="evenodd">
      <circle fill="#000" fill-rule="nonzero" cx="28" cy="28" r="28" />
      <path d="M30.908 25.856 41.108 14H38.69l-8.856 10.294L22.76 14h-8.158L25.3 29.567 14.602 42h2.417l9.353-10.871L33.842 42H42L30.907 25.856zm-3.31 3.848-1.085-1.55L17.89 15.82h3.713l6.959 9.954 1.083 1.55 9.046 12.94H34.98l-7.382-10.56z" fill="#FFF" />
    </g>
  </svg>
</template>
